<template>
    <activix-badge bg-color-class="bg-gray-700" text-color-class="text-gray-100">
        <span data-testid="badge-label" class="text-xs font-semibold uppercase">
            {{ t('smsCommunication.archived') }}
        </span>
    </activix-badge>
</template>

<script setup lang="ts">
    import ActivixBadge from '@/components/elements/ActivixBadge.vue';
    import { useI18n } from '@/hooks/useI18n.ts';

    const { t } = useI18n();
</script>
